import { FuzTypeCreateSurvey } from "./SurveyDefinitions/FuzType.Create.Survey"


export default class SurveyService {
    async getFuzTypeCreateSurvey() {
        return FuzTypeCreateSurvey
    }
}

